export default __webpack_public_path__ + "resources/icons/d110-8466.png";